/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Kind of a single close-all outcome entry.
 */
export enum CloseAllOutcomeKind {

    OrderCancel = 'order_cancel',

    PositionClose = 'position_close'
}
